import { render, staticRenderFns } from "./EventInterface.vue?vue&type=template&id=84a666f6&scoped=true&"
import script from "./EventInterface.vue?vue&type=script&lang=js&"
export * from "./EventInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a666f6",
  null
  
)

export default component.exports